import React, { Component } from 'react'
import Drawer from 'material-ui/Drawer'
import IconButton from 'material-ui/IconButton'
import NavigationClose from 'material-ui/svg-icons/navigation/close'
import AppBar from 'material-ui/AppBar'
import LoginForm from './LoginForm'
import MenuItems from './MenuItems'

import Progress from './Progress'

class LeftDrawer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: false
    }
  }

  toggleLoadingState = () => {
    this.setState(
      { loading: !this.state.loading },
      () => {}
    )
  }

  render() {
    const {
      open,
      handleToggle,
      handleOnRequestChange,
      user,
      setBodyState,
      toggleSaveOcrData,
      handleLogout
    } = this.props
    return (
      <Drawer
        open={open || !user}
        onRequestChange={handleOnRequestChange}
        width={300}
        docked={false}>
        <AppBar
          showMenuIconButton={false}
          title={user || 'Please login...'}
          onRightIconButtonTouchTap={handleToggle}
          iconElementRight={
            <IconButton>
              <NavigationClose />
            </IconButton>
          }
        />
        <Progress loading={this.state.loading} />
        {!user ? (
          <LoginForm
          toggleLoadingState={this.toggleLoadingState}
          setBodyState={setBodyState} />
        ) : (
          <MenuItems
            toggleSaveOcrData={toggleSaveOcrData}
            mode={this.props.mode}
            handleLogout={handleLogout}
          />
        )}
      </Drawer>
    )
  }
}

export default LeftDrawer



// WEBPACK FOOTER //
// ./src/components/LeftDrawer.js